import { FigIcon } from '../FigIcon';

const DOT = { size: 'size-4' } as const;

/** PIN entry dots — filled up to `count`, tinted by `color`. */
export function PinDots({ len, count, color }: { len: number; count: number; color: string }) {
  return (
    <div className="flex items-center gap-4">
      {Array.from({ length: len }).map((_, i) => {
        const filled = i < count;
        return (
          <span
            key={i}
            className={`${DOT.size} rounded-full border`}
            style={{
              backgroundColor: filled ? color : 'transparent',
              borderColor: filled ? color : 'rgb(var(--muted))',
            }}
          />
        );
      })}
    </div>
  );
}

function Key({ onPress, children }: { onPress: () => void; children: React.ReactNode }) {
  return (
    <button
      // Fire on pointer-down (not click) so each digit registers instantly.
      onPointerDown={(e) => {
        e.preventDefault();
        onPress();
      }}
      className="grid size-20 touch-manipulation select-none place-items-center rounded-full bg-surface active:opacity-70"
    >
      {children}
    </button>
  );
}

/** The standard 3×4 PIN keypad (shared by the PIN and seed-reveal screens). */
export function Numpad({
  onPress,
  onBackspace,
}: {
  onPress: (d: string) => void;
  onBackspace: () => void;
}) {
  return (
    <div className="grid grid-cols-3 gap-5">
      {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (
        <Key key={d} onPress={() => onPress(d)}>
          <span className="text-[28px] leading-none text-ink">{d}</span>
        </Key>
      ))}
      <span className="size-20" />
      <Key onPress={() => onPress('0')}>
        <span className="text-[28px] leading-none text-ink">0</span>
      </Key>
      <Key onPress={onBackspace}>
        <FigIcon name="add" size={36} className="rotate-45 text-ink" />
      </Key>
    </div>
  );
}
